import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CoginitoIdentityDataService {

  constructor() {
  }


  getCoginitoIdentityData() {
    let applicationData = localStorage;
    let Bil_Auth_Data = {};
    let BilAuthServiceDataKey = Object.keys(applicationData);

    BilAuthServiceDataKey.forEach((key) => {
      if (key.includes('CognitoIdentityServiceProvider')) {
        let AuthArray = key.split('.');
        let AuthObjKey = AuthArray[AuthArray.length - 1];
        Bil_Auth_Data[AuthObjKey] = applicationData[key];
      }
    });

    return Bil_Auth_Data;
  }

  getAuthToken() {
    let data = this.getCoginitoIdentityData();
    return data['accessToken'] ? data['accessToken'] : (localStorage.getItem('X-AUTH-TOKEN') ? localStorage.getItem('X-AUTH-TOKEN') : null);
  }

  getUserDetails() {
    let data = this.getCoginitoIdentityData();
    let userData = JSON.parse(data['userData']).UserAttributes.filter((x) => x.Name == 'name');
    return userData[0].Value || null;
  }
  getUserUUID() {
    let data = this.getCoginitoIdentityData();
    let userData = JSON.parse(data['userData']).UserAttributes.filter((x) => x.Name == 'custom:useruuId');
    return userData[0].Value || null; 
  }
  
  getUserGmail() {
   let data = this.getCoginitoIdentityData();
    let userData = JSON.parse(data['userData']).UserAttributes.filter((x) => x.Name == 'email');
    return userData[0].Value || null; 
  }

  getUserStatus() {
    let data = this.getCoginitoIdentityData();
    let userData = JSON.parse(data['userData']).UserAttributes.filter((x) => x.Name == 'email_verified');
    return userData[0].Value || null; 
  }

  getUserID() {
    let data = this.getCoginitoIdentityData();
    let userData = JSON.parse(data['userData']).Username;
    console.log(userData, 'userData');
    return userData || null;  
  }

}
